import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SpecSheet } from './dto/spec-sheet.entity';
import { SpecSheetService } from './spec-sheet.service';
import { SpecSheetController } from './spec-sheet.controller';
import { SpecSheetAdpater } from './dto/spec-sheet.adapter';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
    imports:[
        TypeOrmModule.forFeature([SpecSheet])
    ],
  controllers:[SpecSheetController],
  providers:[SpecSheetService,SpecSheetAdpater,ApplicationExceptionHandler,LogsService],
  exports:[SpecSheetService],

})
export class SpecSheetModule{}
